import { ReactNode } from 'react';
import { StyledPageLayout, StyledPageLayoutContent } from './styles';

interface PageLayoutRootProps {
  children: ReactNode;
  contentPadding?: {
    vertical?: number;
    horizontal?: number;
  };
  header?: ReactNode;
}

export const PageLayoutRoot = ({ children, contentPadding, header }: PageLayoutRootProps) => {
  return (
    <StyledPageLayout>
      {header}
      <StyledPageLayoutContent
        verticalpadding={contentPadding?.vertical}
        horizontalpadding={contentPadding?.horizontal}
      >
        {children}
      </StyledPageLayoutContent>
    </StyledPageLayout>
  );
};
